import axios from 'axios';
import {token} from '../services/Authentication'

class ConnectionService {

  static test(param) {
            
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/connection/test`,
      headers: {        
        "content-type": "application/stream+json",
        "authorization": token(), 
      },
      data: param,
    }).then((res) => res).catch((error) => {            
      throw error
    })

  }

  static connectionType() {
    
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/typeconnection`,
      headers: {        
        // "content-type": "application/stream+json",
        "authorization": token(),
      }
    })
    .then((res) => res, (error) => {throw error})

  }

  static connectionSetupSave(param) {
      
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/connector`,
      headers: {              
        "authorization": token(),
      },
      data: param,
    })
    .then((res) => res, (error) => {throw error})
  }

  static connectionSetupGet(id) {
    
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/connector/${id}`,
      headers: {              
        "authorization": token(),
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static connectionSetupDelete(id) {
      
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/connector/${id}`,
      headers: {              
        "authorization": token(),
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static connectionSearch() {
      
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/connector/all`,
      headers: {              
        "authorization": token(),
      },
      data: {},
    })
    .then((res) => res, (error) => {throw error})
  }

}

export default ConnectionService;